import {linear} from 'modules/ease.js';

export default function () {

    return linear(1);
};
